import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=ab8f8144"
import script from "./sub-menu.vue?vue&type=script&lang=js"
export * from "./sub-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab8f8144')) {
      api.createRecord('ab8f8144', component.options)
    } else {
      api.reload('ab8f8144', component.options)
    }
    module.hot.accept("./sub-menu.vue?vue&type=template&id=ab8f8144", function () {
      api.rerender('ab8f8144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/main/components/side-menu/sub-menu.vue"
export default component.exports